import { ApproverDetails } from "../../../types/claim";
import { InvoiceStatus } from "../../../types/invoice";
import { PaymentStatus, PaymentOrderStatus } from "../../../types/payment";
import { UserRole } from "../../../types/userCurrent";
import PreAndPaymentStatusBadge from "../../payment/components/PreAndPaymentStatusBadge";

import InvoiceStatusBadge from "./InvoiceStatusBadge";
import useIsPreviousApproverApproved from "../../payment/hooks/useIsPreviousApproverApproverd";

type InvoicePaymentStatusBadgeProps = {
    roles: UserRole[];
    currentUserEmail?: string;
    invoiceStatus: InvoiceStatus;
    paymentOrderStatus?: PaymentOrderStatus;
    paymentStatus?: PaymentStatus | null;
    paymentOrderApprovers?: ApproverDetails[];
    isListView: boolean;
};

const InvoicePaymentStatusBadge = ({
    roles,
    currentUserEmail,
    invoiceStatus,
    paymentOrderStatus,
    paymentStatus,
    paymentOrderApprovers,
}: InvoicePaymentStatusBadgeProps): JSX.Element => {
    const isPreviousPriorityApproverApproved = useIsPreviousApproverApproved(
        paymentOrderApprovers ?? [],
    );

    const currentApprover = paymentOrderApprovers?.find(
        (it) => it.details.email === currentUserEmail,
    );

    if (
        paymentOrderStatus &&
        invoiceStatus === InvoiceStatus.FINANCE_APPROVED
    ) {
        return (
            <PreAndPaymentStatusBadge
                roles={roles}
                paymentOrderStatus={paymentOrderStatus}
                paymentStatus={paymentStatus}
                isListView={true}
                showActionRequired={true}
                isPreviousPriorityApproverApproved={
                    isPreviousPriorityApproverApproved
                }
                approverStatus={currentApprover?.status}
            />
        );
    } else {
        return <InvoiceStatusBadge roles={roles} status={invoiceStatus} />;
    }
};

export default InvoicePaymentStatusBadge;
